import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalService } from './services/global.service';

@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [
    GlobalService
  ]
})
export class SharedModule { }